import {
  DefaultApi,
  GetDocumentationDto,
  GetVersionInfoDto,
} from '../autogenerated/spdApiClient';

export interface DocumentationContextInterface {
  getForFilename: (filename: string) => Promise<GetDocumentationDto>;
  getExternalFile: (address: string) => Promise<GetDocumentationDto>;
  getVersionInfo: () => Promise<GetVersionInfoDto>;
}

export const DocumentationContext = (api: DefaultApi) => {
  return {
    getForFilename: (filename: string) =>
      api.documentationControllerGetForFilename(filename),
    getExternalFile: (address: string) =>
      api.documentationControllerGetExternalFile(address),
    getVersionInfo: () => api.documentationControllerGetVersionInfo(),
  };
};
